import { render, staticRenderFns } from "./addpay.vue?vue&type=template&id=3c572522"
import script from "./addpay.vue?vue&type=script&lang=js"
export * from "./addpay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports